import React, { useState } from "react";
import { motion } from "framer-motion";
import "./index.less";
import { ICollapsibleCardProps } from "./interface";
import ZButton from "@atoms/ZButton";
import ZIcon from "@atoms/ZIcon";
import ZTypography from "@atoms/ZTypography";
import { EColors } from "@atoms/ZColors/interface";
import { EIcons } from "@atoms/ZIcon/interface";

const CollapsibleCardContent: React.FC<ICollapsibleCardProps> = React.memo(
	({ showIcon = true, ...props }) => {
		const [expand, setExpand] = useState(false);
		const handleButtonClick = () => {
			setExpand(a => {
				props.onCollapseStatusChange?.(!a);
				return !a;
			});
		};
		return (
			<div className="z-collapsible-card-content">
				<motion.div
					initial={false}
					transition={{
						stiffness: 100
					}}
					variants={{
						open: { height: "auto" },
						collapsed: { height: props.collapsedHeight ?? 250 }
					}}
					className={`overflow-hidden ${
						props.hideExpand ? "max-height-250" : ""
					}`}
					animate={expand ? "open" : "collapsed"}
					key={props.collapsedHeight}
				>
					{props.children}
				</motion.div>
				<div
					className={`overlay-shadow ${expand ? "" : "mt-4"} ${
						props.hideExpand ? "mb-4" : ""
					} ${props.buttonContainerClassName ?? ""}`}
				>
					{props.customRender}
					{!props.hideExpand && (
						<ZButton
							onClick={handleButtonClick}
							type="link"
							className="w-full"
						>
							{showIcon && (
								<ZIcon
									name={
										expand
											? EIcons.CHEVRONDOUBLEUP
											: EIcons.CHEVRONDOUBLEDOWN
									}
									color={EColors.BLUE}
									colorVariant={6}
									size="sm"
									className="ml-0 mr-2"
								/>
							)}
							<ZTypography.ZText
								color={EColors.BLUE}
								colorVariant={6}
							>
								View {expand ? "less" : "more"}{" "}
								{props.customTriggerText || ""}
							</ZTypography.ZText>
						</ZButton>
					)}
				</div>
			</div>
		);
	}
);

export default CollapsibleCardContent;
